// Lightweight helpers for Meta Pixel & gtag conversion tracking.
// Safe to call even if the corresponding script hasn't loaded.

export function trackMetaPixel(eventName, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', eventName, params);
    }
  } catch (e) {
    // noop
  }
}

export function trackGoogleAdsConversion(sendTo, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: sendTo,
        ...params,
      });
    }
  } catch (e) {
    // noop
  }
}
